<template>
  <div style="background-color: #fff;">
    <EducationHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjrc-cyzk.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <FilterInfo :list="getFilterInfo" @changeValue="getFilterSearch($event)" />
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            产业智库
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="dataSource">
            <template #renderItem="{ item }">
              <div class="listBox" @click="goDetail(item.id)">
                <div class="leftBox">
                  <img v-if="item.thinkTankLogo" :src="getImg(item.thinkTankLogo)" alt="">
                  <img v-else src="@/assets/img/defaultImg.png" alt="">
                </div>
                <div class="right">
                  <div class="title">{{ item.thinkTankName }}</div>
                  <div class="content">{{ item.title }}</div>
                </div>
                <div class="btn">
                  <a-button type="primary" ghost>查看详情</a-button>
                </div>
              </div>
            </template>
          </a-list>
        </div>
      </div>
    </div>
      <layout-footer/>
  </div>
</template>
<script>
import { getDistMixin, listMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import FilterInfo from '@/components/other/FilterInfo';
import { homeEducationInfo } from "@/api/educationService";
import { file_service } from "@/api/adminService";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2.vue";

const pagination = {
  pageSize: 8,
  showQuickJumper: true,
};
export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin],
  components: {LayoutFooter, EducationHeader, FilterInfo },
  data() {
    return {
      pagination,
      title: '',
      queryParam: { professionalTitle: '' },
      listUrl: homeEducationInfo.zhikuList,
      current: 1,
      // pageSize: 4,
    }
  },
  created() {
    this.getDist('thinktank_type')
    this.title = this.$route.query.type
  },
  mounted() {
  },
  computed: {
    getFilterInfo() {
      let list = []
      let obj = {}
      let obj1 = {}
      let obj2 = {}
      let obj3 = {}
      obj1['智库类型'] = this.thinktanktypeArr
      obj['search'] = 'thinkTankType'
      obj2['arr'] = obj1
      obj3 = Object.assign(obj, obj2)
      list.push(obj3)
      return list
    }
  },
  methods: {
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
    goDetail(id) {
      this.$router.push({
        path: '/educationService/components/thinktankDetail',
        query: { type: '产业智库', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 10px auto;

  .industrialBox {
    width: 1200px;
    margin: 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;

      .listBox {
        position: relative;
        overflow: hidden;
        padding: 10px 0;
        cursor: pointer;
        border-bottom: 1px solid #dedede;

        .leftBox {
          float: left;
          width: 400px;
          height: 225px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .right {
          float: left;
          margin-left: 2%;
          width: 64%;
          font-size: 14px;

          .title {
            padding: 10px 0;
            font-size: 20px;
            color: #333;
            font-weight: 500;
          }

          .content {
            overflow: hidden;
            margin: 10px 0;
            color: #666;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }

        .btn {
          position: absolute;
          bottom: 12px;
          left: 35%;
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
